import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Select from "react-select";
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { API_RESERVATIONS, API_RESERVATIONS_PREVIEW_CANCEL, API_TICKETS, getDataFromUrl } from '../../../api';
import { dialogService } from "@/utils/dialogService";
const SingleOptions = [
    { value: 'Choices 1', label: 'Choices 1' },
    { value: 'Choices 2', label: 'Choices 2' },
    { value: 'Choices 3', label: 'Choices 3' },
    { value: 'Choices 4', label: 'Choices 4' }
];
const ReservationCancel = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [itemState, setItemState] = useState({
        "id": 0,
        "예약신청일": "2022-12-02T18:18:23.445312",
        "예약상품": "텐트이용권",
        "자리": "6",
        "예약자": "이혜란",
        "번호": "01083220075",
        "예약시작일": "2022-12-10",
		"예약종료일": "2022-12-10",
        "이용기간": 1,
        "예약상태": "예약",
        "결제상태": "예약완료"
    });
    const [cancelAmounts, setCancelAmounts] = useState({
        "id": 0,
        "phone_num": 0,
        "amount": 0,
		"cancel_amount": 0,
		"effective_cancel_amount": 0,
		"refundable_option_amount": 0,
    });
    const [selectedMulti, setselectedMulti] = React.useState(null);
    function handleMulti(selectedMulti) {
        setselectedMulti(selectedMulti);
    }
    React.useEffect(() => {
        if (id !== '0') {
            getDataFromUrl(`${API_RESERVATIONS}/${id}`)
                .then(data => {
                console.log(data);
                setItemState({ id, ...data });
            })
                .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
        }
    }, []);
    React.useEffect(() => {
        if (itemState.id) {
            getDataFromUrl(`${API_RESERVATIONS_PREVIEW_CANCEL}/${id}`)
                .then(data => {
                console.log(data);
                setCancelAmounts({ id, ...data });
            })
                .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
        }
    }, [itemState]);
    return (<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<BreadCrumb title="예약 취소" pageTitle="예약"/>
					<div className="flex flex-wrap -mx-3">
						<div className="w-full px-3">
							예약번호
						</div>
						<div className="w-full px-3">
							{itemState.id}
						</div>
					</div>
					<div style={{ marginTop: "10px" }}></div>
					<div className="flex flex-wrap -mx-3">
						<div className="w-full px-3">
							<div className="card">
								<div className="card-body">
									<div className="live-preview">
										<div className="flex flex-wrap -mx-3">
											<div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="" className="form-label">
														이용기간
													</label>
													<div>
														<p style={{ color: "#666" }}>{itemState.예약시작일}</p>
														<p style={{ color: "#666" }}>{itemState.예약종료일}</p>
														<p>{itemState.이용기간} 일</p>
													</div>
												</div>
											</div>
											<div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="ForminputState" className="form-label">사유</label>
													<select defaultValue={"고객변심"} onChange={(e) => (console.log(e.target.value))} id="ForminputState" className="form-select" data-choices data-choices-sorting="true">
														<option key="1" value="고객변심">고객변심</option>
														<option key="2" value="관리자 취소">관리자 취소</option>
														<option key="3" value="기타">기타</option>
													</select>
												</div>
											</div>
											<div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="spotCount" className="form-label">
														자리
													</label>
													<div>
														<p style={{ color: "#1a73e8" }}>{itemState.예약상품}</p>
														<p>{itemState.자리} 번</p>
													</div>
												</div>
											</div>
											{cancelAmounts.id ? <><div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="amount" className="form-label">금액</label>
													<input type="number" className="form-control" placeholder="" id="amount" value={cancelAmounts.amount} onChange={(e) => { }} min="0"/>
												</div>
											</div>
											<div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="cancel-amount" className="form-label">취소비용</label>
													<input type="number" className="form-control" placeholder="" id="cancel-amount" value={Math.max(cancelAmounts.amount - cancelAmounts.cancel_amount, 0)} onChange={(e) => { }} min="0"/>
												</div>
											</div>
											<div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="option-refund-amount" className="form-label">옵션 환불금액</label>
													<input type="number" className="form-control" placeholder="" id="option-refund-amount" value={cancelAmounts.refundable_option_amount} onChange={(e) => { }} min="0"/>
												</div>
											</div>
											<div className="w-full md:w-1/2 px-3">
												<div className="mb-3">
													<label htmlFor="result-amount" className="form-label">환불금액</label>
													<input type="number" className="form-control" placeholder="" id="result-amount" value={cancelAmounts.effective_cancel_amount || cancelAmounts.cancel_amount} onChange={(e) => { }} min="0"/>
												</div>
											</div>
											<div className="w-full px-3">
												<p className="text-muted mb-0">예약 환불 시 연결된 미사용 옵션도 함께 환불됩니다.</p>
											</div></> : null}
										</div>
									</div>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>
		</React.Fragment>);
};
export default ReservationCancel;
